import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=37e5b814&"
import script from "../../models/analysis/coupon.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/coupon.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports